export enum ModeloGrade {
	PARAIBA = 'PARAIBA',
//ARREDOR_DA_PARAIBA = 'ARREDOR_DA_PARAIBA',
	NORDESTE = 'NORDESTE',
}

export const getLabelModeloGrade = (grade: ModeloGrade | string): string => {
	switch (grade) {
		case ModeloGrade.PARAIBA:
			return 'Paraíba (1km)';
		/*case ModeloGrade.ARREDOR_DA_PARAIBA:
			return 'Arredor da Paraíba (9km)';*/
		case ModeloGrade.NORDESTE:
			return 'Nordeste (27km)';
		default:
			return '';
	}
};

export const getResolucaoEspacialGrade = (
	grade: ModeloGrade
): number | undefined => {
	switch (grade) {
		case ModeloGrade.PARAIBA:
			return 1;
		/*case ModeloGrade.ARREDOR_DA_PARAIBA:
			return 9;*/
		case ModeloGrade.NORDESTE:
			return 27;
		default:
			return undefined;
	}
};
